module.exports = __webpack_public_path__ + "static/doctor_mobile-8312a4c4373bfcc98563cf1f1b0ee124.png";